import React, { useCallback, useRef, useState } from 'react';
import Layout from '../Components/Layout/Layout';
import { Link, useNavigate } from 'react-router-dom';
import ArrowBrad from "../Components/Images/bradcumb-ico.svg";
import CloudImage from "../Components/Images/cloude-ico.svg";
import { useForm } from 'react-hook-form';
import { ImageUpload, PostApi, PostApiWithoutLogin } from '../apiService';
import { API_PATH } from '../const';
import { toast } from 'react-toastify';
import { serialize } from "object-to-formdata";
import AsyncSelect from 'react-select/async';

export default function AddAdv() {

    const navigate = useNavigate();
    const usechange = useRef();

    const { 
        register, 
        handleSubmit, 
        getValues,
        reset,
        formState: { errors }, 
    } = useForm(); 

    const[image_path, set_image_path] = useState("");
    
    const [image, setImage] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [active, set_active] = useState(1);
    const [locale, set_locale] = useState("L");
    const [selectedOption, set_selectedOption] = useState({});
    
    const onSubmit = useCallback( async() => {
        if(selectedOption.id === undefined) {
            toast.error("select the city")
            return;
        }

        let data = getValues();
        data.status = active;
        data.locale_brand = locale;
        data.image_path = await handleIamgeUpload();

        
        data.location_id = selectedOption.id;
        if(data.image_path === null || data.image_path === undefined) {
            setImage(null);
            toast.error("Please reupload the image.");
            return;
        }

        const SumbitInquiryForm = Promise.resolve(PostApi(API_PATH.NewAdv, data));
        SumbitInquiryForm.then(response => {
            if(response.status === 200){
                toast.success("New Advertise Added.")
                navigate("/advertisements");
            } else toast.error(response.response.data?.message ?? "Could not upload your advertise.");
        })
    }, [getValues, image, selectedOption]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setPreviewUrl(URL.createObjectURL(file));
        }
    };

    const handleIamgeUpload = () => {
        return new Promise((resolve) => {
            if (image === null || image === undefined){ 
                resolve(null);
            } else {
                const formData = new FormData();
                formData.append('public_image', image);

                const UploadImageRequest = Promise.resolve(ImageUpload(API_PATH.ImageUploadRoute, formData));
                UploadImageRequest.then(response => {
                    if(response.status === 200){
                        toast.success("Image saved!");
                        resolve(response.data?.data?.image_path ?? null);
                    } else {
                        toast.error("Error occured while uploading image.");
                        resolve(null);
                    }
                })
            }
        })
    }

    const customStyles = {
        control: styles => ({ 
            ...styles,
            height: "100%",
            backgroundColor: "none",
            color: "#e5e7eb",
            borderColor: "#e5e7eb"
        }),
        input: (styles) => ({ ...styles, color: '#000000' }),
        placeholder: (styles) => ({ ...styles, color: '#e5e7eb' }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: "#fff",
            color: "#000000",
            height: "100%",
            textAlign: "left",
            ":hover": {
                color: "#f5bf6a",
                backgroundColor: "#fffcef",
            },
        }),
    };

    const handleChange = (option) => set_selectedOption(option);

    const get_dynamiclly = (searchparams, call = null) => new Promise(resolveField => {
        let formData = { searchparams };
        const GetLocationsRequest = new Promise((resolve, reject) => resolve(PostApiWithoutLogin(API_PATH.GetLocations, formData)));
        GetLocationsRequest.then((response) => {
            if (response.status === 200) resolveField(response.data?.data?.locations)
            else toast.error(response.data.message);
        });
    })

    return (
        <Layout>
            <div className="nav-top-section">
                <div className="container-fluid ">
                    <div className="row">
                        <div className="col-12">
                            <div className="bradcumb-text d-flex align-items-center">
                                <Link to="/advertisements">Advertisements</Link>
                                <img src={ArrowBrad} loading="lazy" alt="" />
                                <span>Add/Modify Advertise</span>
                            </div>
                            <div className="bx-white-main">
                                <h2>Add/Modify New Advertise</h2>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="row me-0">
                                        <div className="col-12 pe-0 mb-2 pb-1">
                                            <label className="lbl-info-common">
                                                Title*
                                            </label>
                                            <input type="text" 
                                            className="form-control form-style-input" 
                                            placeholder="Enter advertainment name" name="" 
                                            {...register("name", { required: "Please Enter Title for Your Advertisement" })}
                                            />
                                        </div>
                                        <div className="col-12 pe-0 mb-2 pb-1">
                                            <label className="lbl-info-common">
                                                URL
                                            </label>
                                            <input type="text" 
                                            className="form-control form-style-input" 
                                            placeholder="https://www.example.com" name="" 
                                            {...register("url")}
                                            />
                                        </div>
                                        <div className="col-12 pe-0 mb-2 pb-1">
                                            <label className="lbl-info-common">City</label>
                                            {/* <select 
                                            className="form-select form-style-input"
                                            {...register("location_id", { required: "Please select location" })}
                                            >
                                                <option selected>Select city</option>
                                                <option value={8465}>Ahmedabad</option>
                                                <option value={9417}>Surat</option>
                                                <option value={7770}>Rajkot</option>
                                            </select> */}
                                            <AsyncSelect
                                                ref={usechange}
                                                cacheOptions
                                                defaultOptions
                                                className="w-100 bg-none border-white placeholder-white !text-white"
                                                styles={customStyles}
                                                placeholder="Select Location"
                                                value={selectedOption}
                                                onChange={handleChange}
                                                loadOptions={get_dynamiclly}
                                                formatOptionLabel={(options) => (
                                                    <div className="device-option">
                                                        <span className="text-drop-hdr-menu">{options.PostOfficeName}, {options.City} - {options.Pincode}</span>
                                                    </div>
                                                )}
                                            />
                                        </div>
                                        <div className="col-12 pe-0 mb-2 pb-1">
                                            <label className="lbl-info-common">Banner Image</label>
                                            {! previewUrl || !image ? <div className='file-upload-section position-relative text-center'>
                                                <input 
                                                type="file" 
                                                onChange={(e) => handleImageChange(e)}
                                                />
                                                <img className='m-auto' src={CloudImage} loading="lazy" alt="" />
                                                <span className="d-block">Upload image</span>
                                                <bdi className="d-block">Image must be 1200 x 800 px</bdi>
                                                <p className='m-auto'>Choose File</p>
                                            </div> :
                                            <div className='file-upload-section position-relative text-center'>
                                                <img style={{height: "170px"}} className='m-auto img-thumbnail img-fluid' src={previewUrl} loading="lazy" alt="" />
                                                <span className="d-block fst-italic text-danger" onClick={() => setPreviewUrl(null)}>Remove Image</span>
                                            </div>}
                                        </div>
                                        <div className="col-12 pe-0 mb-2 pb-1">
                                            <div className="d-inline-block align-middle me-4">
                                                <label className="lbl-info-common">Status</label>
                                                <div className="d-inline-flex align-items-center radio-cust-button">
                                                    <div className="form-check">
                                                        <input 
                                                        className="form-check-input" 
                                                        type="radio" name="Status" 
                                                        id="Active" checked={active === 1}
                                                        onClick={() =>set_active(1)}
                                                        />
                                                        <label className="form-check-label" for="Active">
                                                            Active
                                                        </label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input className="form-check-input"
                                                        type="radio" name="Status"
                                                        id="Disable"
                                                        checked={active === 0}
                                                        onClick={() =>set_active(0)}
                                                        />
                                                        <label className="form-check-label" for="Disable">
                                                            Disable
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-inline-block align-middle">
                                                <label className="lbl-info-common">Type</label>
                                                <div className="d-inline-flex align-items-center radio-cust-button">
                                                    <div className="form-check">
                                                        <input className="form-check-input" 
                                                        type="radio" name="LocalBrand" id="Locale" 
                                                        checked = {locale === "L"}
                                                        onClick={() => set_locale("L")}
                                                        />
                                                        <label className="form-check-label" for="Locale">
                                                            Locale
                                                        </label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="radio" name="LocalBrand" id="Brand" 
                                                        checked = {locale === "B"}
                                                        onClick={() => set_locale("B")}
                                                        />
                                                        <label className="form-check-label" for="Brand">
                                                            Brand
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pt-2 text-md-end text-center frm-btn-btm">
                                        <button className="btn-all-cancel" type="button">
                                            Cancel
                                        </button>
                                        <button className="btn-all-comn" type="submit">
                                            Add Advertainment
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}